import { layout } from '@prisjakt/ui-base';
import styled from 'styled-components';

const SIZE = '25px';

export const IconWrapper = styled.span`
  background-color: ${p => p.theme.colors.positive500};
  border-radius: 8px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: ${SIZE};
  width: ${SIZE};
`;

export const OurChoiceInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: ${layout.measurements.spacing050};

  > h4 {
    margin: 0;
  }
`;
